import * as React from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

import {
  CopyCatalogScreen,
  copyCatalogSearchSchema,
  type CopyCatalogSearch,
} from '@/features/copy/CopyCatalogScreen';

export const Route = createFileRoute('/_authed/copy/')({
  validateSearch: copyCatalogSearchSchema,
  component: CopyCatalogRoute,
});

function CopyCatalogRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate();
  const onSearchChange = React.useCallback(
    (patch: Partial<CopyCatalogSearch>) => {
      void navigate({
        to: '/copy',
        search: (prev) => {
          const next: Record<string, unknown> = { ...prev };
          for (const [k, v] of Object.entries(patch)) {
            if (v === undefined || v === '') delete next[k];
            else next[k] = v;
          }
          return next;
        },
        replace: true,
      });
    },
    [navigate]
  );
  return <CopyCatalogScreen search={search} onSearchChange={onSearchChange} />;
}
